import _Cascader from "antd-mobile/es/components/cascader";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component } from 'react';
var LocMobile = /*#__PURE__*/function (_Component) {
  _inherits(LocMobile, _Component);
  function LocMobile(props) {
    _classCallCheck(this, LocMobile);
    return _possibleConstructorReturn(this, _getPrototypeOf(LocMobile).call(this, props));
  }
  _createClass(LocMobile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        cascaderVisible = _this$props.cascaderVisible,
        location = _this$props.location,
        locationMap = _this$props.locationMap,
        changeLocation = _this$props.changeLocation,
        closeCascader = _this$props.closeCascader;
      return React.createElement("div", {
        className: "lotteryPicker"
      }, React.createElement(_Cascader, {
        options: locationMap,
        visible: cascaderVisible,
        value: location,
        onConfirm: function onConfirm(location) {
          return changeLocation(location);
        },
        onCancel: closeCascader
      }));
    }
  }]);
  return LocMobile;
}(Component);
export { LocMobile as default };